// src/api/chat.ts
import apiClient from './client';
import { ChatMessage } from '@/hooks/useWebSocketChat';
import { ChatSummary, SummaryContent } from '@/types/chatCompletion';

export async function fetchMessages(): Promise<ChatMessage[]> {
  const { data } = await apiClient.get<ChatMessage[]>('/api/chat/history');
  return data;
}

export async function fetchChatHistory(): Promise<ChatMessage[]> {
  const { data } = await apiClient.get<ChatMessage[]>('/api/chat/history');
  return data;
}

interface SendMessageResponse {
  message: string;
  pollUrl: string;
}

export async function sendMessage(text: string): Promise<SendMessageResponse> {
  const { data } = await apiClient.post<SendMessageResponse>('/api/chat/send-async', { text });
  return data;
}

interface PollResponse {
  status: 'pending' | 'completed' | 'error';
  response?: string;
  error?: string;
}

export async function pollMessageResponse(pollUrl: string): Promise<PollResponse> {
  const { data } = await apiClient.get<PollResponse>(pollUrl);
  return data;
}

// Summary Management Endpoints
export async function getSummary(userModuleId: number): Promise<ChatSummary> {
  const { data } = await apiClient.get<ChatSummary>(`/api/chat/summaries/${userModuleId}`);
  return data;
}

interface UpdateSummaryRequest {
  content: {
    sections: Record<string, string>;
  };
}

export async function updateSummary(summaryId: number, content: UpdateSummaryRequest): Promise<ChatSummary> {
  const { data } = await apiClient.put<ChatSummary>(`/api/chat/summaries/${summaryId}`, content);
  return data;
}

export async function finalizeSummary(summaryId: number): Promise<ChatSummary> {
  const { data } = await apiClient.post<ChatSummary>(`/api/chat/summaries/${summaryId}/finalize`);
  return data;
}

interface RegenerateSectionResponse {
  section: string;
  newContent: string;
}

export async function regenerateSection(summaryId: number, sectionName: string): Promise<RegenerateSectionResponse> {
  const { data } = await apiClient.post<RegenerateSectionResponse>(
    `/api/chat/summaries/${summaryId}/regenerate-section?section_name=${sectionName}`
  );
  return data;
}